import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import _debounce from "lodash/debounce";
import { provideAuth } from "shared/context/auth";
import { provideTheme } from "shared/context/theme";
import { Container, Divider } from "shared/layout";
import Logo from "shared/components/Logo";
import navigation from "./navigation";
import search from "./search";
import { getAutocomplete, postClickthrough } from "./search/service";
import styles from "./styles.css";
import themes from "./themes";

class GlobalHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      searchResults: [],
    };

    this.debouncedFetch = _debounce(this.fetchResults, 100);
  }

  fetchResults = (value) =>
    getAutocomplete(value).then((json) => {
      this.setState({
        searchResults: json.data,
      });
    });

  handleSearchChange = ({ target }) => {
    const { value } = target;

    this.setState({
      searchTerm: value,
    });

    this.debouncedFetch(value);
  };

  handleResultClick = (swiftypeId) => {
    const { searchTerm } = this.state;

    return postClickthrough(searchTerm, swiftypeId);
  };

  render() {
    const { theme } = this.props;
    const { searchTerm, searchResults } = this.state;

    return (
      <header className={theme.styles.globalHeader} role="banner">
        <Container className={theme.styles.container}>
          <Logo className={theme.styles.logo} />

          <React.Fragment key="desktop">
            <search.Desktop
              className={theme.styles.searchDesktop}
              searchTerm={searchTerm}
              searchResults={searchResults}
              onChange={this.handleSearchChange}
              onResultClick={this.handleResultClick}
            />

            <navigation.Desktop className={theme.styles.navigationDesktop} />
          </React.Fragment>

          <React.Fragment key="mobile">
            <search.Mobile
              className={theme.styles.searchMobile}
              searchTerm={searchTerm}
              searchResults={searchResults}
              onChange={this.handleSearchChange}
              onResultClick={this.handleResultClick}
            />

            <navigation.Mobile className={theme.styles.navigationMobile} />
          </React.Fragment>
        </Container>

        {theme.name !== "blue" && (
          <Divider className={theme.styles.divider} container />
        )}
      </header>
    );
  }
}

GlobalHeader.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string.isRequired,
    styles: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default translate()(
  provideAuth(provideTheme(GlobalHeader, styles, themes))
);
